import { Stack } from "@mui/material";
import DailyPOBReportDesktop from "../components/desktop/daily-pob-report/DailyPOBReportDesktop";

const DailyPOBReport = () => {
  return (
    <Stack gap={2} m={2}>
      <DailyPOBReportDesktop />
    </Stack>
  );
};

export default DailyPOBReport;
